


































































































































































import { Component, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import storage from 'baimahu/storage';
import moment, { Moment } from 'moment';
const profile = storage.getItem('profile') || {};
const merchant_id = profile.merchant_id || '';
const { VUE_APP_FCAPI: FCAPI } = process.env;
const _ = {
  keyBy: require('lodash/keyBy'),
  each: require('lodash/forEach'),
  map: require('lodash/map'),
};

const API = {
  add_bargain: `${FCAPI}/shang/promotion/bargain/spu`,
  get_bargain_info: `${FCAPI}/shang/promotion/bargain/spu/`,
};

interface Form {
  title: string;
  bargain_after: string | number;
  bargain_stock: string;
  invite_number: string;
  bargain_time: string;
  activity_time: Moment[];
  activity_rule: string;
  cardinality: string;
  multiples: string;
}
interface Validator {
  field: string;
  validate: (value: any, avtivity: Form) => boolean;
  message: string;
  status: 'success' | 'error';
  help: string;
}

function getValidatorMap(): { [field: string]: Validator } {
  const list: any[] = [
    {
      field: 'title',
      validate: (value: string): boolean => !!value,
      message: '请输入砍价标题',
    },
    {
      field: 'bargain_after',
      validate: (value: string): boolean => !!value,
      message: '请输入砍后价',
    },
    {
      field: 'bargain_stock',
      validate: (value: string): boolean => !!value,
      message: '请输入砍价库存',
    },
    {
      field: 'invite_number',
      validate: (value: string): boolean => !!value,
      message: '请输入邀请人数',
    },
    {
      field: 'bargain_time',
      validate: (value: string): boolean => !!value,
      message: '请输入砍价有效期',
    },
    {
      field: 'activity_time',
      validate: (value: string): boolean => value.length > 0,
      message: '请选择活动时间',
    },
  ].map((item): Validator => ({ ...item, status: 'success', help: '' }));
  return _.keyBy(list, (item: Validator) => item.field);
}

function getForm(remote?: any): Form {
  remote = remote || {};
  return {
    title: remote.title || '',
    bargain_after: remote.price / 100 || '',
    bargain_stock: remote.stock || '',
    invite_number: remote.invite_number || '',
    bargain_time: remote.useful_life || '',
    activity_time: remote.start_time ? [moment(remote.start_time * 1000), moment(remote.end_time * 1000)] : [],
    activity_rule: remote.rule_text || '',
    cardinality: remote.cardinal_number || '',
    multiples: remote.multiple_number || '',
  };
}
@Component
export default class AddBargainFirst extends Vue {
  ware_info: any[] = [];
  configFormLayout: any = {
    labelCol: { span: 3 },
    wrapperCol: { span: 21 },
  };
  validatorMap: { [field: string]: Validator } = getValidatorMap();
  field_watch_list: (() => void)[] = [];
  form: Form = getForm();
  is_loading: boolean = false;
  async clickSubmitBtn() {
    if (!this.validateCommit()) {
      return;
    }
    const send_data = {
      merchant_id,
      ware_id: this.ware_info[0].id,
      title: this.form.title,
      price: +this.form.bargain_after * 100,
      stock: this.form.bargain_stock,
      invite_number: this.form.invite_number,
      useful_life: this.form.bargain_time,
      start_time: this.form.activity_time[0].format('X'),
      end_time: this.form.activity_time[1].format('X'),
      rule_text: this.form.activity_rule,
      cardinal_number: this.form.cardinality,
      multiple_number: this.form.multiples,
    };
    let res;
    if (this.$route.query.id) {
      send_data.ware_id = this.$route.query.ware_id;
      res = await this.$axios.put(`${API.get_bargain_info}${this.$route.query.id}`, send_data);
    } else {
      res = await this.$axios.post(API.add_bargain, send_data);
    }
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    storage.removeItem('ware_info');
    this.$router.push('/');
  }

  // 判断是否有必选项没有填
  validateCommit() {
    const form = this.form as any;
    let is_valid: boolean = true;
    _.each(this.validatorMap, (validator: Validator, field: string) => {
      if (!this.validate(field)) {
        is_valid = false;
      }
    });
    if (!is_valid) {
      this.$message.error('请填入必填项');
    }
    return is_valid;
  }

  validate(field: string) {
    const form = this.form as any;
    const is_valid = this.validatorMap[field].validate(form[field], form);
    this.validatorMap[field].status = is_valid ? 'success' : 'error';
    this.validatorMap[field].help = is_valid
      ? ''
      : this.validatorMap[field].message;
    return is_valid;
  }

  async getBargainInfo(id: number) {
    const res = await this.$axios.get(`${API.get_bargain_info}${id}`);
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.form = getForm(res.data.data);
    this.ware_info.push(res.data.data.ware_info);
  }

  created() {
    if (this.$route.query.id) {
      this.getBargainInfo(+this.$route.query.id);
    } else {
      this.form = getForm();
      this.ware_info.push(JSON.parse(storage.getItem('ware_info')));
    }
    this.field_watch_list = _.map(
      this.validatorMap,
      (validator: Validator, field: string) =>
        this.$watch(`form.${field}`, (val: any) => {
          this.validate(field);
        }),
    );
  }
  beforeDestroy() {
    this.field_watch_list.forEach((unwatch: () => void) => unwatch());
  }
}
